import { BulkMentionActionModel } from './bulk-mention-action.model';
import { BulkUpdateMentionRequestModel } from '../../../api/mentions/model/bulk-update-mention-request.model';
import { MonitoringBulkActionSourceMethodEnum } from '../enums/monitoring-bulk-action-source-method.enum';
import { MentionSearchCriteriaModel } from './mention-search-criteria.model';
import { MentionSearchQueryModel } from './mention-search-query.model';

export class BulkMentionRequestModel {
    sourceMethod: MonitoringBulkActionSourceMethodEnum;
    mentionIds: string[];
    modifications: BulkMentionActionModel;
    searchModel: MentionSearchCriteriaModel;
    applyTaggingTopics: boolean;
    preserveEditsWhileRenormalize: boolean;

    constructor(
        sourceMethod: MonitoringBulkActionSourceMethodEnum,
        modifications: BulkMentionActionModel,
        searchModel?: MentionSearchCriteriaModel,
        mentionIds?: string[],
        applyTaggingTopics?: boolean,
        preserveEditsWhileRenormalize?: boolean
    ) {
        this.sourceMethod = sourceMethod;
        this.modifications = modifications;
        this.searchModel = searchModel;
        this.mentionIds = mentionIds;
        this.applyTaggingTopics = applyTaggingTopics;
        this.preserveEditsWhileRenormalize = preserveEditsWhileRenormalize;
    }

    /**
     * Converts model to api
     */
    toApi(): BulkUpdateMentionRequestModel {
        const bulkUpdateApiModel: BulkUpdateMentionRequestModel = {
            modifications: this.modifications.toApi(),
        };

        bulkUpdateApiModel.applyTaggingSearches = this.applyTaggingTopics;
        bulkUpdateApiModel.preserveEditsWhileRenormalize = this.preserveEditsWhileRenormalize;

        if (this.sourceMethod === MonitoringBulkActionSourceMethodEnum.SEARCH) {
            const query: MentionSearchQueryModel = this.searchModel.query;
            bulkUpdateApiModel.query = query.getApiEntity();
        } else {
            bulkUpdateApiModel.mentionIds = this.mentionIds;
        }

        return bulkUpdateApiModel;
    }

    /**
     * Converts model to api for copying folders to account
     */
    copyFolderToAccountApi(): BulkUpdateMentionRequestModel {
        const bulkUpdateApiModel: BulkUpdateMentionRequestModel = {};

        const modifications = this.modifications.toApi();

        bulkUpdateApiModel.targetFolderId = modifications.targetFolderId;
        bulkUpdateApiModel.targetAccountId = modifications.targetAccountId;

        if (this.sourceMethod === MonitoringBulkActionSourceMethodEnum.SEARCH) {
            const query: MentionSearchQueryModel = this.searchModel.query;
            bulkUpdateApiModel.query = query.getApiEntity();
        } else {
            bulkUpdateApiModel.mentionIds = this.mentionIds;
        }

        return bulkUpdateApiModel;
    }
}
